import { useQuery } from "@tanstack/react-query";
import { contractorApi } from "../api/contractorApi";

export const useFetchContractorRank = () => {

    const headers = [
        { "alias_name": "rank", "label": "Rank", "display_order": 1, is_show: true },
        { "alias_name": "contractor_name", "label": "Contractor", "display_order": 2, is_show: true },
        { "alias_name": "overall_rag", "label": "Overall Rag", "display_order": 3, is_show: true },
        { "alias_name": "on_time_delivery", "label": "Delivery", "display_order": 4, is_show: true },
        { "alias_name": "responsiveness", "label": "Responsiveness", "display_order": 5, is_show: true },
        { "alias_name": "quality_score", "label": "Quality", "display_order": 6, is_show: true },
        { "alias_name": "cost_variance", "label": "Cost variance", "display_order": 7, is_show: true },
        { "alias_name": "overdue_activities", "label": "Overdue", "display_order": 8, is_show: true },
    ];

    const { data, isFetching, isPending, isError, error, refetch } = useQuery({
        queryKey: ["contractor-rank-list"],
        queryFn: () => contractorApi.fetchRankList(),
    });

    return {
        headers,
        data,
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };

};
